import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import getTimezone from 'shared/utils//getTimezone';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { getCurrentLanguage } from 'modules/language/selectors/language';

import createAction from './index';
import * as services from '../services/declineReschedulingOffer';
import { get, has } from 'lodash';
import { setExpired } from './setExpired';
import { GET_RESCHEDULING_OFFER } from './getReschedulingOffer';

export const DECLINE_RESCHEDULING_OFFER = createAsyncAction(createAction('DECLINE_RESCHEDULING_OFFER'));

export const declineReschedulingOffer = () => dispatch => {
  const offerId = location.pathname.split('/')[3];
  if (!offerId) return;

  dispatch({ type: DECLINE_RESCHEDULING_OFFER.pending });

  const apiCallParams = {
    query: services.DECLINE_RESCHEDULING_OFFER,
    variables: {
      offerId,
      localizationOptions: { locale: getCurrentLanguage().toUpperCase(), timezone: getTimezone() },
    },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { declineReschedulingOffer: { message, organizationName } } }) =>
      dispatch({
        type: DECLINE_RESCHEDULING_OFFER.success,
        payload: { message, organizationName },
      }),
    )
    .catch((err) => {
      if (err) {
        if (has(err, 'graphQLErrors')) {
          const apiErrorCodes = err.graphQLErrors.map(err => get(err, 'extensions.code'), 500).map(Number);
          const apiErrors = err.graphQLErrors.map(err => err, 500);
          if (apiErrorCodes.includes(938)) return dispatch(setExpired(apiErrors.find(err => Number(err.extensions.code) === 938).extensions.properties));
        }
      }
      dispatch(errorAction(GET_RESCHEDULING_OFFER.failure, err));
    });
};
